import Box from '@mui/material/Box'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import { CSSProperties, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import KanseiBreadcrumbs from 'components/breadcrumb'
import { companyApi } from 'hooks/api/company'
import { Company } from 'types/company'

export default function CompanyPage() {
  const [companies, setCompanies] = useState<Company[]>([])
  const navigate = useNavigate()

  useEffect(() => {
    companyApi()
      .getAll()
      .then((res) => {
        setCompanies(res.data)
      })
  }, [])

  const handleToDetail = (id: string) => () => {
    navigate(`/cls1/company/${id}/branch`)
  }

  const links = [
    {
      title: '警備会社一覧',
    },
  ]

  return (
    <Box>
      <KanseiBreadcrumbs links={links} style={{ marginBottom: '15px' }} />
      <List>
        {companies.map((company) => (
          <ListItemButton
            key={company.id}
            onClick={handleToDetail(company.id)}
            style={listItemStyle}
          >
            {company.name}
          </ListItemButton>
        ))}
      </List>
    </Box>
  )
}

const listItemStyle: CSSProperties = {
  borderBottom: '1px solid #ccc',
}
